import React from 'react';
import { useConnection } from '@/contexts/ConnectionContext';

interface ConnectionStatusBadgeProps {
  className?: string;
}

export const ConnectionStatusBadge: React.FC<ConnectionStatusBadgeProps> = ({ className = '' }) => {
  const { isOnline, lastChecked, method, forceCheck } = useConnection();

  const handleForceCheck = async () => {
    await forceCheck();
  };

  return (
    <div className={`flex items-center space-x-2 ${className}`}>
      <div className={`w-2 h-2 rounded-full ${isOnline ? 'bg-green-500' : 'bg-red-500'}`} />
      <span className="text-sm font-medium">
        {isOnline ? 'En ligne' : 'Hors ligne'}
      </span>
      <button
        onClick={handleForceCheck}
        className="p-1 hover:bg-gray-200 rounded-full transition-colors"
        title={`Dernière vérification: ${lastChecked.toLocaleTimeString()} (${method})`}
      >
        <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
        </svg>
      </button>
    </div>
  );
};
